import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './assets/css/DocumentDocTypeModal.css';
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import PaginationComponent from "../util/PaginationComponent";
import LoadingScreen from "../util/LoadingScreen";
import CustomPagination from "../util/CustomPagination";


const DocumentSelectRequiredModal = ({ show, onHide, onSave, handleAddDocument }) => {
    const [docTypes, setDocTypes] = useState([]);
    const [selectedDocTypes, setSelectedDocTypes] = useState([]);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});

    const [loading, setLoading] = useState(false); // Estado para controle de carregamento
    const [loadingSave, setLoadingSave] = useState(false); // Estado para controle de carregamento
    const [saving, setSaving] = useState(false); // Estado para controle do salvamento

    useEffect(() => {
        if (show) {
            fetchDocTypes(1);
        }
    }, [show]);

    const fetchDocTypes = async (page) => {
        setLoading(true); // Ativar estado de carregamento
        const response = await   ApiService.send('get', `${process.env.REACT_APP_URL_API}documents/type-docs-list`, { params: { page } }, true);
          try{


                    const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);

                    setDocTypes(data || []);

                    const fetchedDocTypes = data;
                    setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});

                    const selected = fetchedDocTypes
                        .filter(docType => docType.doc_required_type_id !== null)
                        .map(docType => docType.id);
                    setSelectedDocTypes(selected);

          } catch (error) {
              ApiService.handleApiError(error);
          } finally {
              setLoading(false);
          }
    };

    const handleSelectChange = (e) => {
        const { value, checked } = e.target;
        const docTypeId = parseInt(value);

        setSelectedDocTypes(prevState => {
            if (checked) {
                return [...prevState, docTypeId];
            } else {
                return prevState.filter(id => id !== docTypeId);
            }
        });
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoadingSave(true); // Ativar estado de salvamento

        ApiService.send('post', `${process.env.REACT_APP_URL_API}documents/insert`, { typeDocs: selectedDocTypes }, true)
            .then((res) => {

                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: 'Documentos salvos com sucesso.',
                    });

            })
            .catch((error) => {
                console.error('Error saving document types:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response?.data?.message || 'Ocorreu um erro ao salvar os documentos.',
                });
            })
            .finally(() => {
                setLoadingSave(false); // Desativar estado de salvamento
            });
    };

    return (
        <>
            {saving && <LoadingScreen />} {/* Exibir LoadingScreen durante o salvamento */}
            {show && <div className="modal-backdrop fade show"></div>}
            <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" aria-labelledby="documentSelectDocTypeModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="documentSelectDocTypeModalLabel">Selecionar Tipos de Documento</h5>
                            <button type="button" className="btn-close"  onClick={() =>onHide()} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <button type="button" className="btn btn-sm btn-warning mb-3"  onClick={() =>handleAddDocument()}>
                                <i className="fa fa-plus"></i> Cadastro Documento
                            </button>

                            <form onSubmit={handleSave}>
                                <div className="list-group mb-3">
                                    {loading ? (
                                        [...Array(5)].map((_, index) => (
                                            <div className="form-check" key={index}>
                                                <Skeleton width={300}/>
                                            </div>
                                        ))
                                    ) : Array.isArray(docTypes) && docTypes.length > 0 ? (
                                        docTypes.map(docType => (
                                            <div className="form-check" key={docType.id}>
                                                {docType.user_id && (
                                                    <button type="button"
                                                        title="Editar o documento"
                                                        type="button"
                                                        className="btn btn-sm"
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            padding: 0,
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => onSave(docType)}
                                                    >
                                                        <i className="fa fa-edit"></i>
                                                    </button>
                                                )}

                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`docType-${docType.id}`}
                                                    value={docType.id}
                                                    checked={selectedDocTypes.includes(docType.id)}
                                                    onChange={handleSelectChange}
                                                />
                                                <label className="form-check-label" htmlFor={`docType-${docType.id}`}>
                                                    {docType.name}
                                                </label>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="alert alert-primary" role="alert">Nenhum tipo de documento
                                            disponível.</div>
                                    )}
                                </div>

                                <CustomPagination
                                    onChange={pagination}
                                    onChange={(page) => fetchDocTypes(page)}
                                />


                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                            onClick={() => onHide()}><i className="fa fa-close"></i>   Cancelar
                                    </button>
                                    <button type="submit" className="btn btn-info" disabled={loadingSave}>
                                        {loadingSave ? (
                                            <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                                Salvando...
                                            </>
                                        ) : (
                                            <>
                                                <i className={`fa  fa-save me-2`}></i>
                                                 Salvar
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DocumentSelectRequiredModal;
